var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isRead)?_c('span',{staticClass:"mailbox-read-time pull-right"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.markAsRead()}}},[_vm._v(_vm._s(_vm.markAsReadString))])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16602dd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/admin/notifications/markAsReadButton.vue
// module id = 8Sgl
// module chunks = 0